define([
    'jQuery',
    '../blocks/confirm-dialog/confirm-dialog',
    '../blocks/alert-dialog/alert-dialog',
    '../mediators/AddDialog',
    '../blocks/wait-layer/wait-layer',
], ($, BConfirm, BAlert, AddDialog, WaitLayer) => {
    return {
        wait(settings) {
            return new Promise((resolve /* , reject */) => {
                const layer = new WaitLayer({
                    el: $('<div/>').appendTo('.layers'),

                    data: settings,
                });
                const onAction = function() {
                    layer.hide();
                    layer.destroy();
                    resolve();
                };

                settings.action.then(onAction).catch(onAction);

                layer.show();
            });
        },

        alert(settings) {
            'use strict';
            return new Promise((resolve /* , reject */) => {
                const layer = new BAlert({
                    el: $('<div/>').appendTo('.layers'),

                    data: settings,

                    onDone() {
                        this._finish(true);
                    },

                    _finish(answer) {
                        layer.hide();
                        layer.destroy();
                        resolve(answer);
                    },
                });

                layer.show();
            });
        },

        prompt(settings) {
            return new Promise((resolve, reject) => {
                const layer = new AddDialog({
                    el: $('<div/>').appendTo('.layers'),

                    titleText: settings.header,
                    approveText: settings.ok,
                    labelText: settings.label || null,
                    errors: settings.errors,
                    desc: settings.desc || null,
                    placeholder: settings.placeholder,
                    validator(data) {
                        return settings.validator
                            ? settings.validator(data)
                            : true;
                    },
                });

                layer.on('approve', (data) => {
                    layer.hide();
                    layer.destroy();
                    resolve(data);
                });

                layer.on('cancel', () => {
                    layer.destroy();
                    reject();
                });

                layer.show();
            });
        },

        confirm(settings) {
            return new Promise((resolve /* , reject */) => {
                const layer = new BConfirm({
                    el: $('<div/>').appendTo('.layers'),

                    data: settings,

                    onApprove() {
                        this._finish(true);
                    },

                    onCancel() {
                        this._finish(false);
                    },

                    _finish(answer) {
                        resolve(answer);
                        layer.hide();
                        layer.destroy();
                    },
                });

                layer.show();
            });
        },
    };
});
